export const ENTER = 'Enter';
export const COMMA = ',';
export const BACKSPACE = 'Backspace';
export const WINDOW_MOBILE_WIDTH_MARGIN = 1024;
export const IMAGE_RESIZE_MODE = 'contain';
export const SEARCH_OR_CREATE_NEW_TAGS = 'Search or create new tag';

